<template>
  <div class="form-container">
    <fields class="mb-4" @filter="clickSummary" :summary="summary" :reset="reset" />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center">
        <div class="mr-2">List New Need Approval</div>
        <div>
          <b-dropdown
            menu-class="shadow"
            variant="link"
            toggle-class="text-decoration-none"
            boundary="#header"
            no-caret
          >
            <template #button-content>
              <div>
                <fa-icon class="text-info" icon="sliders-h" />
              </div>
            </template>
            <b-dropdown-form>
              <b-form-select
                v-model="filters.filter_field"
                :options="fieldOptions"
                size="sm"
                class="mt-2"
                @change="fetchFilter"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    Please select an option
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-input
                v-if="filters.filter_field === 'periode' || filters.filter_field === 'created_at'"
                v-model="filters.filter_value"
                type="month"
                size="sm"
                class="my-3"
              />
              <b-form-select
                v-else-if="filters.filter_field === 'report_type' || filters.filter_field === 'status'"
                v-model="filters.filter_value"
                :options="optionsValue"
                size="sm"
                class="my-3"
                :disabled="!filters.filter_field || optionsValue.length === 0"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    Please select an option
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-select
                v-else
                v-model="filters.filter_value"
                :options="optionsValue"
                text-field="name"
                value-field="name"
                size="sm"
                class="my-3"
                :disabled="!filters.filter_field || optionsValue.length === 0"
              />
              <div class="d-flex justify-content-around mb-2">
                <b-button
                  class="btn-reset"
                  variant="outline-info"
                  size="sm"
                  @click="resetFilter"
                >
                  Reset
                </b-button>
                <b-button
                  class="btn-custom"
                  variant="info"
                  size="sm"
                  @click="$refs.dashboardTable.refresh()"
                >
                  Apply
                </b-button>
              </div>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.dashboardTable.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      thead-class="table-list-header"
      empty-text="No data"
      ref="dashboardTable"
      :items="fetchDashboard"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template #cell(report_type)="{ item }">
        <a class="d-block text-dark" :href="link(item)">
          {{ item.report_type == 'Summary HmEwh' ? 'Summary HM & EWH' : item.report_type }}
        </a>
      </template>
      <template v-slot:cell()="{ value, item }">
        <a class="d-block h-100 text-dark" :href="link(item)">
          {{ value }}
        </a>
      </template>
      <template #cell(created_at)="{ item }">
        <a class="d-block text-dark" :href="link(item)">
          {{`${formatDate(item.created_at)}`}}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">{{ items.item.status }}</div>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Fields from './Field'
import moment from 'moment'

export default {
  components: {
    Fields
  },

  data: () => ({
    visible: false,
    isBusy: false,
    search: '',
    currentPage: 1,
    perPage: 10,
    totalRows: 0,
    sortBy: 'contractor',
    sortDesc: false,
    fields: [
      { key: 'report_type', label: 'Report Type', sortable: true, thClass: 'start' },
      { key: 'contractor', sortable: true },
      { key: 'created_at', label: 'Submission Date', sortable: true },
      { key: 'periode', label: 'Period', sortable: true },
      { key: 'status', label: 'Approval Status', sortable: true, thClass: 'end' }
    ],
    items: [],
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    valueOptions: [],
    filters: {
      filter_field: null,
      filter_value: null
    },
    selected: null,
    fieldOptions: [
      { value: 'report_type', text: 'Report Type' },
      { value: 'contractor', text: 'Contractor' },
      { value: 'created_at', text: 'Submission Date' },
      { value: 'periode', text: 'Period' },
      { value: 'status', text: 'Status' }
    ],
    optionsValue: [],
    summary: {},
    reset: false
  }),

  created() {
    this.fetchSummary()
    this.search = 'Waiting'
  },

  methods: {
    async fetchSummary() {
      this.summary = await api.dashboard.summary()
    },
    async fetchDashboard() {
      const data = await api.dashboard.list({
        sort_by: this.sortBy,
        sort_desc: this.sortDesc ? 'desc' : 'asc',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        filter_field: this.filters.filter_field,
        filter_value: this.filters.filter_value
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []
      this.reset = false
      return this.items
    },
    resetFilter() {
      this.filters = this.$options.data().filters
      this.$refs.dashboardTable.refresh()
      this.search = 'Waiting'
      this.reset = true
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY')
    },
    link(item) {
      switch (item.report_type) {
        case 'Work Order':
          return `/work-order/${item.id}/detail`
        case 'Logsheet':
          return `/log-sheet/${item.id}/detail`
        case 'Summary HmEwh':
          return `/summary-hm-ewh/detail?${item.id ? `hm_id=${item.id}` : `wo_id=${item.wo_id}&unit_id=${item.unit_id}`}`
        case 'Summary Progress':
          return `/summary-progress/detail?${item.id ? `sp_id=${item.id}` : `wo_id=${item.wo_id}`}`
        case 'PAF1':
        case 'PAF2':
          return `/payment-auth/detail?${item.id ? `paf_id=${item.id}` : `contractor_id=${item.contractor_id}`}`
        default:
          return '/dashboard'
      }
    },
    goDetail(item) {
      switch (item.report_type) {
        case 'Work Order':
          this.$router.push({ path: `/work-order/${item.id}/detail` })
          break
        case 'Logsheet':
          this.$router.push({ path: `/log-sheet/${item.id}/detail` })
          break
        case 'Summary HmEwh':
          this.$router.push({ path: `/summary-hm-ewh/detail?${item.id ? `hm_id=${item.id}` : `wo_id=${item.wo_id}&unit_id=${item.unit_id}`}` })
          break
        case 'Summary Progress':
          this.$router.push({ path: `/summary-progress/detail?${item.id ? `sp_id=${item.id}` : `wo_id=${item.wo_id}`}` })
          break
        case 'PAF1':
        case 'PAF2':
          this.$router.push({ path: `/payment-auth/detail?${item.id ? `paf_id=${item.id}` : `contractor_id=${item.contractor_id}`}` })
          break
        default:
          this.$router.push({ path: '/dashboard' })
          break
      }
    },
    async fetchFilter() {
      let data = []
      if (this.filters.filter_field === 'report_type') {
        data = [
          { value: 'Summary HmEwh', text: 'Summary HmEwh' },
          { value: 'Summary Progress', text: 'Summary Progress' },
          { value: 'Rental Equipment', text: 'Rental Equipment' },
          { value: 'Payment Auth', text: 'PAF' },
          { value: 'Work Order', text: 'Work Order' },
          { value: 'Logsheet', text: 'Logsheet' }
        ]
      }
      if (this.filters.filter_field === 'status') {
        data = [
          'Draft',
          'Waiting',
          'Revise',
          'Approved'
        ]
      }
      if (this.filters.filter_field === 'contractor') {
        try {
          data = await api.contractor.list()
        } catch (error) {}
      }
      this.optionsValue = data
    },
    statusChange(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    clickSummary(value) {
      this.filters.filter_field = 'status'
      this.filters.filter_value = value === 'Approved' ? value : 'Waiting'
      this.search = value
      this.$refs.dashboardTable.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
.text-selected {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
